export default __webpack_public_path__ + "static/media/9001_2015_rev_02_2026.a97f0e2a.pdf";